import { ComponentProps } from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';
import AnimatedDotsCarousel, { DotConfig } from 'react-native-animated-dots-carousel';
import { Required } from 'utility-types';

import { colors } from '../../../theme';

const DEFAULT_MAX_INDICATORS = 5;

export const PaginationDots = ({
	currentIndex,
	length,
	bottomOffset = 0,
	style,
	...props
}: Props) => {
	return (
		<View style={[styles.container, style, { bottom: bottomOffset }]}>
			<AnimatedDotsCarousel
				currentIndex={currentIndex}
				length={length}
				maxIndicators={DEFAULT_MAX_INDICATORS}
				interpolateOpacityAndColor
				activeIndicatorConfig={activeDotConfig}
				inactiveIndicatorConfig={inactiveDotConfig}
				decreasingDots={[
					{
						quantity: 1,
						config: decreasingDotConfig,
					},
				]}
				{...props}
			/>
		</View>
	);
};

const sharedDotConfig = {
	margin: 4,
	opacity: 1,
};

const sharedBorderConfig = {
	borderColor: colors.white,
	borderWidth: 2,
};

const activeDotConfig: DotConfig = {
	...sharedDotConfig,
	...sharedBorderConfig,
	color: colors.primary,
	size: 16,
};

const inactiveDotConfig: DotConfig = {
	...sharedDotConfig,
	...sharedBorderConfig,
	size: 12,
	color: colors.secondaryDisabled,
};

const decreasingDotConfig: DotConfig = {
	...sharedDotConfig,
	size: 4,
	color: colors.secondaryDisabled,
};

const styles = StyleSheet.create({
	container: {
		alignItems: 'center',
		justifyContent: 'center',
		position: 'absolute',
		paddingBottom: 10,
		height: 36,
		width: '100%',
	},
});

interface Props extends Required<
	Partial<ComponentProps<typeof AnimatedDotsCarousel>>,
	'currentIndex' | 'length'
> {
	style?: ViewProps['style'];
	bottomOffset?: number;
}
